/**
 * Route definition for /chains/monad-testnet
 *
 * Renders the shared ChainPage with the `monad-testnet` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/monad-testnet
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/monad-testnet')({
  component: function MonadTestnetChainPage() {
    return <ChainPage slug="monad-testnet" />
  },
})
